"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _authorisation = _interopRequireDefault(require("../../authorisation"));

var _projectResetView = _interopRequireDefault(require("../../project-reset-view"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ResetBrunches = new _authorisation.default(['admin', 'projectresponsible'], ['brunch'], false)(_projectResetView.default);
var ResetLockpfostens = new _authorisation.default(['admin', 'projectresponsible'], ['lockpfosten'], false)(_projectResetView.default);
var ResetToh = new _authorisation.default(['admin', 'projectresponsible'], ['toh'], false)(_projectResetView.default);

var ProjectResetSection = /*#__PURE__*/function (_React$Component) {
  _inherits(ProjectResetSection, _React$Component);

  function ProjectResetSection() {
    _classCallCheck(this, ProjectResetSection);

    return _possibleConstructorReturn(this, (ProjectResetSection.__proto__ || Object.getPrototypeOf(ProjectResetSection)).apply(this, arguments));
  }

  _createClass(ProjectResetSection, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("section", {
        className: 'project-reset-section'
      }, /*#__PURE__*/_react.default.createElement("h2", null, t('Reset projects')), /*#__PURE__*/_react.default.createElement(ResetBrunches, {
        title: t('Reset brunch projects data'),
        requestResetProjectRegistration: this.props.requestBrunchResetProjectRegistration,
        confirmText: t('Reset brunch projects'),
        closeText: t('close'),
        modalTitle: t('Reset brunch confirmation'),
        resetButtonText: t('Reset'),
        description: t('reset brunch description')
      }), /*#__PURE__*/_react.default.createElement(ResetLockpfostens, {
        title: t('Reset lockpfosten projects data'),
        requestResetProjectRegistration: this.props.requestLockpfostenResetProjectRegistration,
        confirmText: t('Reset lockpfosten projects'),
        closeText: t('close'),
        modalTitle: t('Reset Lockpfosten confirmation'),
        resetButtonText: t('Reset'),
        description: t('reset lockpfosten description')
      }), /*#__PURE__*/_react.default.createElement(ResetToh, {
        title: t('Reset toh projects data'),
        requestResetProjectRegistration: this.props.requestTohResetProjectRegistration,
        confirmText: t('Reset toh projects'),
        closeText: t('close'),
        modalTitle: t('Reset toh confirmation'),
        resetButtonText: t('Reset'),
        description: t('reset toh description')
      }));
    }
  }]);

  return ProjectResetSection;
}(_react.default.Component);

ProjectResetSection.propTypes = {
  t: _propTypes.default.func.isRequired,
  requestBrunchResetProjectRegistration: _propTypes.default.func.isRequired,
  requestLockpfostenResetProjectRegistration: _propTypes.default.func.isRequired,
  requestTohResetProjectRegistration: _propTypes.default.func.isRequired
};
var _default = ProjectResetSection;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/project-reset-container/lib/reset-section.js
// module id = 762
// module chunks = 0